<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12">
        <b-card no-body class="border-0 shadow-sm bg-dark text-white overflow-hidden polished-card">
          <b-card-body class="p-4">
            
            <!-- HEADER -->
            <div class="d-flex align-items-center justify-content-between mb-4">
              <div class="d-flex align-items-center">
                <div class="bg-danger-soft rounded p-3 mr-3 shadow-sm-glow">
                  <i class="fa fa-keyboard-o fa-2x text-danger"></i>
                </div>
                <div>
                  <h4 class="mb-0 font-weight-bold letter-spacing-1 text-uppercase">Macro Analysis</h4>
                  <div class="text-muted smaller font-weight-bold uppercase letter-spacing-2">Detailed Input Report: {{ $route.params.username }}</div>
                </div>
              </div>
              <b-button variant="outline-secondary" @click="$router.go(-1)" class="font-weight-bold">
                <i class="fa fa-arrow-left mr-2"></i> BACK
              </b-button>
            </div>

            <!-- CONTENT -->
            <div v-if="loading" class="text-center py-5">
              <b-spinner variant="danger" type="grow" label="Loading..."></b-spinner>
              <p class="text-muted mt-3 font-weight-bold smaller uppercase letter-spacing-1">Analyzing Input Patterns...</p>
            </div>

            <div v-else-if="details && details.length > 0">
              <div class="d-flex justify-content-between align-items-center mb-3 px-2">
                <span class="text-muted font-weight-bold uppercase smaller">Activity Timeline</span>
                <b-badge variant="dark" class="border border-secondary px-3 py-1">{{ details.length }} Days Active</b-badge>
              </div>

              <div class="list-group list-group-flush rounded-lg overflow-hidden">
                <div 
                  v-for="(item, index) in details" 
                  :key="index" 
                  class="list-group-item bg-darker border-dark-accent d-flex justify-content-between align-items-center py-3 px-4 hover-row"
                >
                  <div class="d-flex align-items-center">
                    <div class="date-icon mr-3 text-center" style="min-width: 50px;">
                      <span class="d-block font-weight-bold h4 mb-0 text-white-90">{{ getDay(item.Date) }}</span>
                      <span class="d-block text-muted smaller uppercase font-weight-bold">{{ getMonth(item.Date) }}</span>
                    </div>
                    <div class="border-left border-dark-light pl-3 ml-2">
                      <span class="d-block font-weight-bold text-white-90 h5 mb-0">{{ formatDate(item.Date) }}</span>
                      <span class="text-muted smaller">Daily Aggregate</span>
                    </div>
                  </div>
                  
                  <div class="text-right">
                    <span class="d-block h3 font-weight-bold text-danger mb-0">{{ item.MacroInputs }}</span>
                    <span class="text-danger smaller font-weight-bold uppercase letter-spacing-1">Inputs Detected</span>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="text-center py-5">
              <i class="fa fa-check-circle fa-4x text-success mb-4 opacity-50"></i>
              <h4 class="text-white-90">No detailed records found.</h4>
              <p class="text-muted smaller">The macro detection system has not flagged specific daily activity for this user.</p>
            </div>

          </b-card-body>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import Servers from '../../../_servers'

export default {
  name: 'MacroDetails',
  data() {
    return {
      loading: true,
      servers: Servers
    }
  },
  computed: {
    ...mapGetters({
      details: 'macroDetails'
    })
  },
  created() {
    this.fetchData()
  },
  watch: {
    details() {
      this.loading = false
    }
  },
  methods: {
    fetchData() {
      if (!this.hasPermission(this.MacroView)) {
        this.loading = false
        return
      }
      this.loading = true
      // Clear old data
      this.$store.commit('setMacroDetails', [])
      
      const username = this.$route.params.username
      const server = this.$route.query.server || 'gold'

      if (this.servers[server] && this.servers[server].readonly) {
        this.loading = false
        return
      }
      
      this.emit('getMacroDetails', {
        username: username,
        server: server
      })
    },
    formatDate(date) {
      return moment(date).format('dddd, YYYY-MM-DD')
    },
    getDay(date) {
      return moment(date).format('DD')
    },
    getMonth(date) {
      return moment(date).format('MMM')
    }
  }
}
</script>

<style scoped>
.bg-darker { background-color: #1a1d21 !important; }
.bg-danger-soft { background-color: rgba(248, 108, 107, 0.15); }
.border-dark-accent { border-color: #2c3035 !important; }
.border-dark-light { border-color: rgba(255,255,255,0.1) !important; }
.text-white-90 { color: rgba(255,255,255,0.95); }
.shadow-sm-glow { box-shadow: 0 0 15px rgba(248, 108, 107, 0.15); }

.hover-row { transition: background-color 0.2s; }
.hover-row:hover { background-color: #23272b !important; }

.letter-spacing-1 { letter-spacing: 1px; }
.letter-spacing-2 { letter-spacing: 2px; }
.smaller { font-size: 0.75rem; }

/* Polished Card from other views */
.polished-card {
  border-radius: 0.5rem;
}
</style>
